import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2),
}));

export const LoadingImage = styled("img")(() => ({
  width: 80,
  height: 80,
  objectFit: "contain",
}));

export const LoadingText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const Dots = styled("span")(() => ({
  display: "inline-block",
  width: "1.5em",
  textAlign: "left",
}));
